import { render, staticRenderFns } from "./m-explainText.vue?vue&type=template&id=47fd99ce&scoped=true&"
import script from "./m-explainText.vue?vue&type=script&lang=ts&"
export * from "./m-explainText.vue?vue&type=script&lang=ts&"
import style0 from "./m-explainText.vue?vue&type=style&index=0&id=47fd99ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd99ce",
  null
  
)

export default component.exports